import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// German locale imports
import deCommon from './locales/de/common.json';
import deProfile from './locales/de/profile.json';
import deSSW from './locales/de/ssw.json';
import deOnboarding from './locales/de/onboarding.json';
import deErrors from './locales/de/errors.json';
import deSubscription from './locales/de/subscription.json';
import dePregnancyInfo from './locales/de/pregnancyInfo.json';
import dePartner from './locales/de/partner.json';
import deNotifications from './locales/de/notifications.json';
import deGdpr from './locales/de/gdpr.json';
import deDashboard from './locales/de/dashboard.json';
import deBabyDevelopment from './locales/de/babyDevelopment.json';
import deTools from './locales/de/tools.json';
import deContractionTimer from './locales/de/contractionTimer.json';
import deNames from './locales/de/names.json';
import deChecklists from './locales/de/checklists.json';
import deCalendar from './locales/de/calendar.json';
import deScanner from './locales/de/scanner.json';
import deGuides from './locales/de/guides.json';
import deBabyCare from './locales/de/babyCare.json';
import deBabyGrowth from './locales/de/babyGrowth.json';
import deAIChat from './locales/de/aiChat.json';
import deHelp from './locales/de/help.json';
import deAuth from './locales/de/auth.json';
import deSleepSounds from './locales/de/sleepSounds.json';
import deSleepPlan from './locales/de/sleepPlan.json';
import deConsent from './locales/de/consent.json';

// English locale imports
import enCommon from './locales/en/common.json';
import enProfile from './locales/en/profile.json';
import enSSW from './locales/en/ssw.json';
import enOnboarding from './locales/en/onboarding.json';
import enErrors from './locales/en/errors.json';
import enSubscription from './locales/en/subscription.json';
import enPregnancyInfo from './locales/en/pregnancyInfo.json';
import enPartner from './locales/en/partner.json';
import enNotifications from './locales/en/notifications.json';
import enGdpr from './locales/en/gdpr.json';
import enDashboard from './locales/en/dashboard.json';
import enBabyDevelopment from './locales/en/babyDevelopment.json';
import enTools from './locales/en/tools.json';
import enContractionTimer from './locales/en/contractionTimer.json';
import enNames from './locales/en/names.json';
import enChecklists from './locales/en/checklists.json';
import enCalendar from './locales/en/calendar.json';
import enScanner from './locales/en/scanner.json';
import enGuides from './locales/en/guides.json';
import enBabyCare from './locales/en/babyCare.json';
import enBabyGrowth from './locales/en/babyGrowth.json';
import enAIChat from './locales/en/aiChat.json';
import enHelp from './locales/en/help.json';
import enAuth from './locales/en/auth.json';
import enSleepSounds from './locales/en/sleepSounds.json';
import enSleepPlan from './locales/en/sleepPlan.json';
import enConsent from './locales/en/consent.json';

export const resources = {
  de: {
    common: deCommon,
    profile: deProfile,
    ssw: deSSW,
    onboarding: deOnboarding,
    errors: deErrors,
    subscription: deSubscription,
    pregnancyInfo: dePregnancyInfo,
    partner: dePartner,
    notifications: deNotifications,
    gdpr: deGdpr,
    dashboard: deDashboard,
    babyDevelopment: deBabyDevelopment,
    tools: deTools,
    contractionTimer: deContractionTimer,
    names: deNames,
    checklists: deChecklists,
    calendar: deCalendar,
    scanner: deScanner,
    guides: deGuides,
    babyCare: deBabyCare,
    babyGrowth: deBabyGrowth,
    aiChat: deAIChat,
    help: deHelp,
    auth: deAuth,
    sleepSounds: deSleepSounds,
    sleepPlan: deSleepPlan,
    consent: deConsent,
  },
  en: {
    common: enCommon,
    profile: enProfile,
    ssw: enSSW,
    onboarding: enOnboarding,
    errors: enErrors,
    subscription: enSubscription,
    pregnancyInfo: enPregnancyInfo,
    partner: enPartner,
    notifications: enNotifications,
    gdpr: enGdpr,
    dashboard: enDashboard,
    babyDevelopment: enBabyDevelopment,
    tools: enTools,
    contractionTimer: enContractionTimer,
    names: enNames,
    checklists: enChecklists,
    calendar: enCalendar,
    scanner: enScanner,
    guides: enGuides,
    babyCare: enBabyCare,
    babyGrowth: enBabyGrowth,
    aiChat: enAIChat,
    help: enHelp,
    auth: enAuth,
    sleepSounds: enSleepSounds,
    sleepPlan: enSleepPlan,
    consent: enConsent,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    defaultNS: 'common',
    ns: ['common', 'profile', 'ssw', 'onboarding', 'errors', 'subscription', 'pregnancyInfo', 'partner', 'notifications', 'gdpr', 'dashboard', 'babyDevelopment', 'tools', 'contractionTimer', 'names', 'checklists', 'calendar', 'scanner', 'guides', 'babyCare', 'babyGrowth', 'aiChat', 'help', 'auth', 'sleepSounds', 'sleepPlan', 'consent'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
export { useTranslation };
export * from './types';
export * from './hooks/useLocale';
export { LocaleProvider, useLocaleContext } from './providers/LocaleProvider';
